export default {
  invoices(state) {
    return state.invoices
  },
  invoice(state) {
    return state.invoice
  },
  invoiceItem(state) {
    return state.invoiceItem
  },
  invoiceFilters(state) {
    return state.invoiceFilters
  },
  invoiceStatuses(state) {
    return state.invoiceStatuses
  },
}
